"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PubSub = function () {
    function PubSub() {
        _classCallCheck(this, PubSub);

        this.handlers = [];
    }

    _createClass(PubSub, [{
        key: "subscribe",
        value: function subscribe(event, handler) {
            this.handlers.push({ event: event, handler: handler });
        }
    }, {
        key: "unsubscribe",
        value: function unsubscribe(event, handler) {
            this.handlers = this.handlers.filter(function (savedHandler) {
                return !(savedHandler.event === event && savedHandler.handler === handler);
            });
        }
    }, {
        key: "publish",
        value: function publish(event, args) {
            this.handlers.filter(function (topic) {
                return topic.event === event;
            }).forEach(function (topic) {
                return topic.handler(args);
            });
        }
    }]);

    return PubSub;
}();

exports.default = PubSub;


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/lib/js/utils/PubSub.js
// module id = 2603
// module chunks = 0